import { render, staticRenderFns } from "./InvitationsTab.vue?vue&type=template&id=6f30e4da&scoped=true"
import script from "./InvitationsTab.vue?vue&type=script&lang=js"
export * from "./InvitationsTab.vue?vue&type=script&lang=js"
import style0 from "./InvitationsTab.vue?vue&type=style&index=0&id=6f30e4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f30e4da",
  null
  
)

export default component.exports